interface LoaderProps  {
    darkMode:any
}
 const Loader = (props:LoaderProps) => {
  return (
    <div className="text-center py-4">
    <div className={`inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2  ${props.darkMode ? 'border-red-100' : 'border-blue-500'} `}></div>
   </div>
  )
}
export default Loader;
